import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core/styles';

export function TimeMarker(props) {
  const { x, theme } = props;
  return (
    <div style={{
      width: '4px',
      height: '50px',
      backgroundColor: theme.lifeline.palette.markers.time,
      position: 'absolute',
      top: '0px',
      left: `${x}px`,
      transform: 'translate(-50%, -15px)',
      borderRadius: '4px',
      zIndex: 300,
      boxShadow: '0 0 0 1px rgba(255,255,255,0.4)',
    }}
    />
  );
}

TimeMarker.propTypes = {
  x: PropTypes.number.isRequired,
  theme: PropTypes.shape().isRequired,
};

export default withTheme()(TimeMarker);



// WEBPACK FOOTER //
// ./src/components/lifeline/Line/TimeMarker.jsx